<template>
  <f7-block id='widget-jira-support'>
  </f7-block>
</template>

<script>


  /*
    TODO:
    - conversie în Vanilla JS pentru folosirea componentei standalone în aplicații standard.
    - revizuire window.setInterval @main frame

  */
  export default {
    name: 'JiraSupport',
    props: {
      data: String
    },
    mounted() {
      const self = this;
      //self.initDeskSupport();
      // jsd-widget append to toolbar-inner

      const elemsToTranslate =  {
          "Subject" : self.$t('jira-support-subject'),
          "Descriere" : self.$t('jira-support-description'),
          "Choose file": self.$t('jira-support-choose_file'),
          "Your contact e-mail": self.$t('jira-support-contact_email'),
          "Send": self.$t('jira-support-send_btn'),
          "Thanks!": self.$t('jira-support-thanks_msg'),
          "Close": self.$t('jira-support-close_btn'),
      };

      self.initDeskSupport(function() {
        var DOMContentLoaded_event = document.createEvent('Event');
        DOMContentLoaded_event.initEvent('DOMContentLoaded', true, true);
        window.document.dispatchEvent(DOMContentLoaded_event);
      });

      window.setInterval(function(){
        if ((self.rerunObserver && !self.rerunInitialized || self.firstRun && !self.rerunObserver) && !self.framesOpened){
          self.rerunInitialized = true;
          self.firstRun = false;
          let themeColor = window.session_jira_color ?? null;

          if (themeColor == null){
            self.appliedThemeColor = true; // nu mai aplicam tema
          }

          if (self.appliedThemeColor == false && themeColor != null){
            self.waitForMainFrameOnly(0).then(function(){
              let mainJiraFrame = document.getElementById(self.jiraIframeWidgetNormalized);
              let styleWithIDLoaded = false;
              
              let interval = window.setInterval(function(){
                let style = mainJiraFrame.contentDocument.querySelector("#widget-theme");
                if (style != null){
                  styleWithIDLoaded = true;
                  if (mainJiraFrame != null && styleWithIDLoaded){
                      self.appliedThemeColor = true;
                      let styleWidgetOverwrites = document.createElement('style');
                      styleWidgetOverwrites.textContent = `
                        .ak-button__appearance-primary,
                        #help-button,
                        #widget-header {
                          background-color: ${themeColor} !important;
                        }
                      `;
                      mainJiraFrame.contentDocument.head.appendChild(styleWidgetOverwrites);
                  }
                  window.clearInterval(interval);
                }
              }, 100);
            }).catch(function(error){
              console.log("A intervenit o eroare in setarea temei - JIRA: " + error);
            });
          }
          //main support frame
          self.waitForMainFrame(self.mainJiraLabelsElementGroup, 0).then(function(){
              self.framesOpened = true;
              let tmpLabels = null;
              let tmpButtons = null;

              let mainJiraFrame = document.getElementById(self.jiraIframeWidgetNormalized);

              tmpLabels = mainJiraFrame.contentDocument.getElementsByTagName('label');
              tmpButtons = mainJiraFrame.contentDocument.getElementsByTagName('button');

              //translations
              for (const [orig, traducere] of Object.entries(elemsToTranslate)){
                for (var element of tmpLabels){
                  if (element.innerText == orig){
                    element.innerText = traducere;
                  }
                  else if (element.htmlFor == "description"){
                    let elemText1 = element;
                    let elemText2 = element;
                    if (elemText1.innerHTML == orig){
                      elemText1.innerHTML = traducere;
                      elemText2.innerHTML = "";
                    }
                  }
                }
                for (var element of tmpButtons){
                  if (element.innerText == orig){
                    element.innerText = traducere;
                  }
                }
              }
              
              //hooks & reworks
              for (var btnElem of tmpButtons){
                if (btnElem.id != "submit-button"){
                  continue;
                }
                if (self.btnSendHooked == false){
                  self.btnSendHooked = true;
                  let docElement = document.getElementById(self.jiraIframeWidgetNormalized);
                  let textAreas = docElement.contentDocument.getElementsByTagName('textarea');
                  let inputAreas = docElement.contentDocument.getElementsByTagName('input');

                  for(var elem of textAreas){ 
                    if (elem.name == self.sessionInfoElementName){
                      self.sessionInfoElement = elem;
                      elem.parentElement.style.display = "none";
                      break;
                    }
                  }

                  btnElem.onclick = function(){
                    if (self.sessionInfoElement != null &&
                        !self.sessionInfoElementHooked
                      ){
                      let token = localStorage.token;
                      let progress = 10; //localStorage.progress; // nu exista in localStorage - nu îl mai punem
                      if (token != null){
                        self.sessionInfoElementHooked = true;
                        let origDescription = self.sessionInfoElement.value;
                        let appendInfo = "Token Sesiune: " + token;
                        self.sessionInfoElement.value = "";
                        self.sessionInfoElement.value = appendInfo;
                        //console.log("s-au inserat datele sesiunii in request.");
                      }
                    }
                  }
                }
              }
  
              
          }).catch(function(error){
              console.log("A intervenit o eroare in mainFrameElement - JIRA: " + error);
          }).finally(function(){
              self.rerunObserver = true;
              self.rerunInitialized = false;
              if (self.framesOpened){
                self.framesOpened = false;
                self.btnSendHooked = false;
              }
          });
          
        }
        if (self.confirmationShouldRun && !self.observerConfirmRunning){
          self.waitForConfirmationFrame(self.jiraConfirmationFrame, 0).then(function(){
            self.confirmationShouldRun = false;

            let mainJiraElement = document.getElementById(self.jiraIframeWidgetNormalized);
            if (mainJiraElement == null){
            }
            // -> confirmation-container
            let confirmationFrameElement = mainJiraElement.contentWindow.document.body.getElementsByClassName(self.jiraConfirmationFrameNormalized);
            let tmpThanksLabel = null;
            let tmpCloseButton = null;

            if (confirmationFrameElement != null){
              tmpThanksLabel = confirmationFrameElement[0].getElementsByTagName("h3");
              tmpCloseButton = confirmationFrameElement[0].getElementsByTagName("button");

              for (const [orig, traducere] of Object.entries(elemsToTranslate)){
                for (let elem of tmpThanksLabel){
                  if (elem.innerHTML == orig){
                    elem.innerHTML = traducere;
                    break;
                  }
                }
                for (let elem of tmpCloseButton){
                  if (elem.innerHTML == orig){
                    elem.innerHTML = traducere;
                    break;
                  }
                }
              }
            }
          }).catch(function(error){
            console.log("A intervenit o eroare in confirmationFrameElement - JIRA: " + error);
          })
          .finally(function(){
            self.confirmationShouldRun = true;
            self.observerConfirmRunning = false;
          });
        }
      }, 500);
    },

    methods:{
      initDeskSupport(callbackFunc){
        const self = this;
        if (!self.widgetRendered){
          self.widgetRendered = true;
          let mainDiv = document.getElementById('widget-jira-support');
          let jiraDeskWidget = document.createElement('script');
          jiraDeskWidget.setAttribute("type", "text/javascript");
          jiraDeskWidget.setAttribute("data-jsd-embedded", "");
          jiraDeskWidget.setAttribute("data-key", self.jiraMainSuppKey);
          jiraDeskWidget.setAttribute("data-base-url", "https://jsd-widget.atlassian.com");
          jiraDeskWidget.setAttribute("src", "https://jsd-widget.atlassian.com/assets/embed.js");
          //jiraDeskWidget.setAttribute("async", true);

          if (jiraDeskWidget.readyState){
            jiraDeskWidget.onreadystatechange = function(){
              if (jiraDeskWidget.readyState == 'loaded' || jiraDeskWidget.readyState == 'complete'){
                jiraDeskWidget.onreadystatechange = null;
                callbackFunc();
              }
            };
          }
          else{
            jiraDeskWidget.onload = function(){
              callbackFunc();
            };
          }
          mainDiv.appendChild(jiraDeskWidget);
        }
      },
      waitForMainFrame(querySelector, timeout){
        const self = this;
        return new Promise((resolve, reject)=>{
            let timer = false;
            let killObserver = false;
            const observer = new MutationObserver(()=>{
                document.querySelectorAll(self.jiraIframeWidget).forEach( item =>{
                    if (item.contentWindow.document.body.querySelectorAll(querySelector).length){
                        killObserver = true;
                    }
                });

                if (killObserver){
                    observer.disconnect();
                    self.rerunObserver = false;
                    if(timer !== false) clearTimeout(timer);
                    return resolve();
                }
            });
            observer.observe(document.body, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            });
            if(timeout > 0) timer = setTimeout(()=>{
                observer.disconnect();
                reject();
            }, timeout);
        });
      },
      waitForMainFrameOnly(timeout){
        const self = this;
        return new Promise((resolve, reject)=>{
            let timer = false;
            let killObserver = false;
            const observer = new MutationObserver(()=>{
                let loaded = document.querySelectorAll(self.jiraIframeWidget) != null;
                if (loaded){
                    killObserver = true;
                }
                if (killObserver){
                    observer.disconnect();
                    self.rerunObserver = false;
                    if(timer !== false) clearTimeout(timer);
                    return resolve();
                }
            });
            observer.observe(document.body, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            });
            if(timeout > 0) timer = setTimeout(()=>{
                observer.disconnect();
                reject();
            }, timeout);
        });
      },
      waitForConfirmationFrame(querySelector, timeout){
        const self = this;
        return new Promise((resolve, reject)=>{
            let timer = false;
            let killObserver = false;
            let iframe = document.getElementById(self.jiraIframeWidgetNormalized);
            if (iframe != null){
              iframe = iframe.contentDocument.body;
              let config = { 
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true  
              }

              let callback = function(mutationsList) {
                self.observerConfirmRunning = true;
                if (iframe.querySelectorAll(querySelector).length){
                  return resolve();
                }
              }
              
              let observer = new MutationObserver(callback);
              observer.observe(iframe, config);
            }
        });
      }
    },
    data(){
      return {
        jiraMainSuppKey: "c190b487-267a-4071-a664-d01e33f76d2f",
        mainJiraLabelsElementGroup: "div[class='ak-field-group']",
        mainJiraButtonsElementGroup: "div[class='buttons']",
        jiraIframeWidget: "iframe[id='jsd-widget']", // sa fim siguri ca dam hook la iframe-ul Jira
        jiraIframeWidgetNormalized: "jsd-widget",
        jiraConfirmationFrame: "div[id='confirmation-container']",
        jiraConfirmationFrameNormalized: "content",
        repositionWidgetPX: "-20px",
        sessionInfoElementName: "customfield_10062",
        sessionInfoElement: null,
        sessionInfoElementHooked: false,
        rerunObserver: false,
        rerunInitialized: false,
        firstRun: true,
        confirmationShouldRun: true,
        observerConfirmRunning: false,
        framesOpened: false,
        widgetRendered: false,
        btnSendHooked: false,
        appliedThemeColor: false,
      }
    }
  }
</script>
